import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="ft-area">
        <img src="/ft-bg.svg" alt="ft-bg" className="ft-bg" />
        <div className="container">
          <div className="row">
            <div className="col-lg-3  col-12">
              <img src="/logo.png" alt="logo" className="ft-logo" />
              <p className="para white">
                Forem ipsum dolor sit amet, consectetur adipiscing elit.Forem
                ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
              <ul className="ft-social">
                <li>
                  <a href="#">
                    <i className="fas fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fas fa-tiktok"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 offset-lg-1 col-6">
              <h3 className="ft-head">Navigation</h3>
              <ul className="ft-list">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/about">About us</a>
                </li>
                <li>
                  <a href="/services">Services</a>
                </li>
                <li>
                  <a href="/our-solutions">Solution</a>
                </li>
                <li>
                  <a href="/contact">Contact us</a>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-6">
              <h3 className="ft-head">Quick link</h3>
              <ul className="ft-list">
                <li>
                  <a href="/contact">Contact</a>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 offset-lg-1 col-12">
              <h3 className="ft-head">Get in Touch</h3>
              <ul className="ft-list">
                <li>
                  <a href="tel:97121234567">
                    <img src="/ph.svg" alt="email" />
                    <span>+971 2 123 4567</span>
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <img src="/loc.svg" alt="email" />
                    <span>
                      Vorem ipsum dolor sit amet, consectetur adipiscing elit.{" "}
                    </span>
                  </a>
                </li>
                <li>
                  <a href="mailto:info@videovision.io">
                    <img src="/email.svg" alt="email" />
                    <span>info@videovision.io </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="ft-btm">
          <div className="container">
            <p>
              Copyright © 2025 <a href="#">video vision media.</a> All Rights
              Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
